export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingresa tus datos de acceso"])},
          "user_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de usuario"])},
          "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contraseña"])},
          "login_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingresar"])},
          "forgot_pass": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Olvidaste tu contraseña?"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter your access data"])},
          "user_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User code"])},
          "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])},
          "login_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Log in"])},
          "forgot_pass": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Forgot your password?"])}
        }
      }
    }
  })
}